const actionCode = [
  { value: 'A', description: 'Add' },
  { value: 'M', description: 'Modify' },
  { value: 'R', description: 'Replace' },
  { value: 'D', description: 'Delete' },
]
export const submissionType = [
  { value: 'ES', description: 'Entry Summary' },
  { value: 'PGA', description: 'PGA Correction' },
]

const entryType = [
  { value: '01', description: 'Consumption - Free & Dutiable' },
  { value: '02', description: 'Consumption - Quota/Visa' },
  { value: '03', description: 'Consumption - AD/CVD' },
  { value: '06', description: 'Foreign Trade Zone (GTZ)' },
  { value: '07', description: 'Consumption - Quota/Visa & AD/CVD' },
  { value: '11', description: 'Informal - Free & Dutiable' },
  { value: '12', description: 'Informal - Quota/Visa' },
  { value: '21', description: 'Warehouse' },
  { value: '22', description: 'Re-warehouse' },
  { value: '23', description: 'Temporary Importation under Bond (TIB)' },
  { value: '31', description: 'Warehouse Withdrawal - Consumption' },
  { value: '32', description: 'Warehouse Withdrawal - Quota' },
  { value: '34', description: 'Warehouse Withdrawal - AD/CVD' },
  { value: '38', description: 'Warehouse Withdrawal - Quota/Visa & AD/CVD' },
  { value: '51', description: 'Military - Defense Contract Management Agency (DCMA)' },
  { value: '52', description: 'Government - Dutiable' },
]

const modeOfTransportation = [
  { value: '10', description: 'Vessel, Non-Containerized' },
  { value: '11', description: 'Vessel, Containerized' },
  { value: '12', description: 'Border Water Borne' },
  { value: '20', description: 'Rail, Non-Containerized' },
  { value: '21', description: 'Rail, Containerized' },
  { value: '30', description: 'Truck, Non-Containerized' },
  { value: '31', description: 'Truck, Containerized' },
  { value: '32', description: 'Auto' },
  { value: '33', description: 'Pedestrian' },
  { value: '34', description: 'Road, Other' },
  { value: '40', description: 'Air, Non-Containerized' },
  { value: '41', description: 'Air, Containerized' },
  { value: '50', description: 'Mail' },
  { value: '60', description: 'Passenger, Hand Carried' },
  { value: '70', description: 'Fixed Transport' },
]

const cargoReleaseProcessing = [
  { value: ' ', description: 'No' },
  { value: 'Y', description: 'Certified via ACE' },
]

const consolidatedIndicator = [
  { value: ' ', description: 'No' },
  { value: 'Y', description: 'Yes' },
]

const shipmentUsage = [
  { value: 'P', description: 'Personal Shipment' },
  { value: 'X', description: 'Sample Commercial Shipment' }
]

const liveEntry = [
  { value: ' ', description: 'No' },
  { value: 'Y', description: 'Yes' },
]

const deferredTax = [
  { value: '1', description: 'Conventional IR tax payment deferral has been arranged' },
  { value: '2', description: 'Electronic Funds Transfer (EFT) IR tax payment deferral has been arranged' },
]

const ftaReconciliation = [
  { value: ' ', description: 'No' },
  { value: 'Y', description: 'Yes' },
]

const otherReconciliation = [
  { value: '001', description: 'Value' },
  { value: '002', description: 'Classification' },
  { value: '003', description: 'Chapter 9802' },
  { value: '004', description: 'Value & Classification' },
  { value: '005', description: 'Value and Chapter 9802' },
  { value: '006', description: 'Classification & Chapter 9802' },
  { value: '007', description: 'Value, Classification & Chapter 9802' }
]

const paymentType = [
  { value: '1', description: 'Individual payment (NOT on a statement)' },
  { value: '2', description: '[Daily] Batched by preliminary statement print date and filer code' },
  { value: '3', description: '[Daily] Batched by preliminary statement print date, filer code, and full importer of record number' },
  { value: '5', description: '[Daily] Batched by preliminary statement print date, filer code, and importer of record number without suffix' },
  { value: '6', description: '[Monthly] Batched by preliminary statement print date and filer code' },
  { value: '7', description: '[Monthly] Batched by preliminary statement print date, filer code, and full importer of record number' },
  { value: '8', description: '[Monthly] Batched by preliminary statement print date, filer code, and importer of record number without suffix' },
]

const bondType = [
  { value: '8', description: 'Continuous' },
  { value: '9', description: 'Single Transaction Bond (STB)' },
]

const bondDesignationType = [
  { value: 'B', description: 'The basic bond' },
  { value: 'A', description: 'An additional bond' },
  { value: 'U', description: 'Substitution single transaction bond' },
  { value: 'E', description: 'Superseding single transaction bond' }
]

const continuousBondIndicator = [
  { value: 'Y', description: 'Continuous bond supersedes the bond presented at time of entry' },
  { value: 'S', description: 'Substitution continuous bond replaces the bond presented at time of entry' }
]

const missingDoc1 = [
  { value: '01', description: 'Commercial Invoice' },
  { value: '10', description: 'CBPF 5523 (19 CFR 141.89)' },
  { value: '11', description: 'CBPF 3291' },
  { value: '14', description: 'Lease Statement (19 CFR 10.108(b))' },
  { value: '15', description: 'Re-melting Certificate (19 CFR 141.89 et al)' },
  { value: '16', description: 'Corrected Commercial Invoice (19 CFR 141.89 et al)' },
  { value: '17', description: 'Other Agency Forms (19 CFR Part 12)' },
  { value: '18', description: 'Duty Free Entry Certificate (19 CFR 10.102); HTS 9808.00.30009' },
  { value: '19', description: 'Scale Weight (19 CFR 151, Subpart B)' },
  { value: '20', description: 'End Use Certificate (19 CFR 10.138)' },
  { value: '21', description: 'Form O (Coffee)' },
  { value: '22', description: 'Chemical Analysis' },
  { value: '23', description: 'Out Turn Report (19 CFR 151, Subpart C)' },
  { value: '26', description: 'Packing List (19 CFR 141.86(e))' },
  { value: '98', description: 'Other document (not listed)' }
]

const missingDoc2 = [
  ...missingDoc1,
  { value: '99', description: 'More than two documents listed' }
]

const pscHeaderReasonCode = [
  { value: 'H01', description: 'Entry Type Non-AD/CVD-to-AD/CVD' },
  { value: 'H02', description: 'Entry Type - Other' },
  { value: 'H04', description: 'Mode of Transportation' },
  { value: 'H05', description: 'Bond - Surety' },
  { value: 'H06', description: 'Bond - Superseding' },
  { value: 'H07', description: 'Bond - Other' },
  { value: 'H08', description: 'Electronic Invoice Availability' },
  { value: 'H09', description: 'Shipment Usage Type' },
  { value: 'H10', description: 'Consignee' },
  { value: 'H11', description: 'Date of Importation' },
  { value: 'H12', description: 'State of Destination' },
  { value: 'H13', description: 'Header Fee' },
  { value: 'H14', description: 'Entry Type AD/CVD-to-Non-AD/CVD' },
  { value: 'H99', description: 'Date Change - Other' }
]

const usStates = [
  { value: 'AL', description: 'Alabama' },
  { value: 'AK', description: 'Alaska' },
  { value: 'AZ', description: 'Arizona' },
  { value: 'AR', description: 'Arkansas' },
  { value: 'CA', description: 'California' },
  { value: 'CO', description: 'Colorado' },
  { value: 'CT', description: 'Connecticut' },
  { value: 'DE', description: 'Delaware' },
  { value: 'FL', description: 'Florida' },
  { value: 'GA', description: 'Georgia' },
  { value: 'HI', description: 'Hawaii' },
  { value: 'ID', description: 'Idaho' },
  { value: 'IL', description: 'Illinois' },
  { value: 'IN', description: 'Indiana' },
  { value: 'IA', description: 'Iowa' },
  { value: 'KS', description: 'Kansas' },
  { value: 'KY', description: 'Kentucky' },
  { value: 'LA', description: 'Louisiana' },
  { value: 'ME', description: 'Maine' },
  { value: 'MD', description: 'Maryland' },
  { value: 'MA', description: 'Massachusetts' },
  { value: 'MI', description: 'Michigan' },
  { value: 'MN', description: 'Minnesota' },
  { value: 'MS', description: 'Mississippi' },
  { value: 'MO', description: 'Missouri' },
  { value: 'MT', description: 'Montana' },
  { value: 'NE', description: 'Nebraska' },
  { value: 'NV', description: 'Nevada' },
  { value: 'NH', description: 'New Hampshire' },
  { value: 'NJ', description: 'New Jersey' },
  { value: 'NM', description: 'New Mexico' },
  { value: 'NY', description: 'New York' },
  { value: 'NC', description: 'North Carolina' },
  { value: 'ND', description: 'North Dakota' },
  { value: 'OH', description: 'Ohio' },
  { value: 'OK', description: 'Oklahoma' },
  { value: 'OR', description: 'Oregon' },
  { value: 'PA', description: 'Pennsylvania' },
  { value: 'RI', description: 'Rhode Island' },
  { value: 'SC', description: 'South Carolina' },
  { value: 'SD', description: 'South Dakota' },
  { value: 'TN', description: 'Tennessee' },
  { value: 'TX', description: 'Texas' },
  { value: 'UT', description: 'Utah' },
  { value: 'VT', description: 'Vermont' },
  { value: 'VA', description: 'Virginia' },
  { value: 'WA', description: 'Washington' },
  { value: 'WV', description: 'West Virginia' },
  { value: 'WI', description: 'Wisconsin' },
  { value: 'WY', description: 'Wyoming' },
  { value: 'DC', description: 'District of Columbia' },
  { value: 'AS', description: 'American Samoa' },
  { value: 'GU', description: 'Guam' },
  { value: 'MP', description: 'Northern Mariana Islands' },
  { value: 'PR', description: 'Puerto Rico' },
  { value: 'UM', description: 'United States Minor Outlying Islands' },
  { value: 'VI', description: 'U.S. Virgin Islands' },
]

const entryNumberSet = [
  { value: 0, description: '0' },
  { value: 1, description: '1' },
  { value: 2, description: '2' },
  { value: 3, description: '3' },
  { value: 4, description: '4' },
  { value: 5, description: '5' },
  { value: 6, description: '6' },
  { value: 7, description: '7' },
  { value: 8, description: '8' },
  { value: 9, description: '9' },
]

const month = [
  { value: '01', description: 'January' },
  { value: '02', description: 'February' },
  { value: '03', description: 'March' },
  { value: '04', description: 'April' },
  { value: '05', description: 'May' },
  { value: '06', description: 'June' },
  { value: '07', description: 'July' },
  { value: '08', description: 'August' },
  { value: '09', description: 'September' },
  { value: '10', description: 'October' },
  { value: '11', description: 'November' },
  { value: '12', description: 'December' },
]

const partyLookup = [
  { value: '1', description: 'Party 1' },
  { value: '2', description: 'Party 2' },
  { value: '3', description: 'Party 3' },
  { value: '4', description: 'Party 4' },
  { value: '5', description: 'Party 5' },
]

const countries = [
  { value: 'AF', description: 'Afghanistan' },
  { value: 'AX', description: 'Åland Islands' },
  { value: 'AL', description: 'Albania' },
  { value: 'DZ', description: 'Algeria' },
  { value: 'AS', description: 'American Samoa' },
  { value: 'AD', description: 'Andorra' },
  { value: 'AO', description: 'Angola' },
  { value: 'AI', description: 'Anguilla' },
  { value: 'AQ', description: 'Antarctica' },
  { value: 'AG', description: 'Antigua and Barbuda' },
  { value: 'AR', description: 'Argentina' },
  { value: 'AM', description: 'Armenia' },
  { value: 'AW', description: 'Aruba' },
  { value: 'AU', description: 'Australia' },
  { value: 'AT', description: 'Austria' },
  { value: 'AZ', description: 'Azerbaijan' },
  { value: 'BS', description: 'Bahamas' },
  { value: 'BH', description: 'Bahrain' },
  { value: 'BD', description: 'Bangladesh' },
  { value: 'BB', description: 'Barbados' },
  { value: 'BY', description: 'Belarus' },
  { value: 'BE', description: 'Belgium' },
  { value: 'BZ', description: 'Belize' },
  { value: 'BJ', description: 'Benin' },
  { value: 'BM', description: 'Bermuda' },
  { value: 'BT', description: 'Bhutan' },
  { value: 'BO', description: 'Bolivia' },
  { value: 'BQ', description: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', description: 'Bosnia and Herzegovina' },
  { value: 'BW', description: 'Botswana' },
  { value: 'BV', description: 'Bouvet Island' },
  { value: 'BR', description: 'Brazil' },
  { value: 'IO', description: 'British Indian Ocean Territory' },
  { value: 'BN', description: 'Brunei Darussalam' },
  { value: 'BG', description: 'Bulgaria' },
  { value: 'BF', description: 'Burkina Faso' },
  { value: 'BI', description: 'Burundi' },
  { value: 'CV', description: 'Cabo Verde' },
  { value: 'KH', description: 'Cambodia' },
  { value: 'CM', description: 'Cameroon' },
  { value: 'CA', description: 'Canada' },
  { value: 'KY', description: 'Cayman Islands' },
  { value: 'CF', description: 'Central African Republic' },
  { value: 'TD', description: 'Chad' },
  { value: 'CL', description: 'Chile' },
  { value: 'CN', description: 'China' },
  { value: 'CX', description: 'Christmas Island' },
  { value: 'CC', description: 'Cocos (Keeling) Islands' },
  { value: 'CO', description: 'Colombia' },
  { value: 'KM', description: 'Comoros' },
  { value: 'CG', description: 'Congo' },
  { value: 'CD', description: 'Congo, Democratic Republic of the' },
  { value: 'CK', description: 'Cook Islands' },
  { value: 'CR', description: 'Costa Rica' },
  { value: 'CI', description: "Côte d'Ivoire" },
  { value: 'HR', description: 'Croatia' },
  { value: 'CU', description: 'Cuba' },
  { value: 'CW', description: 'Curaçao' },
  { value: 'CY', description: 'Cyprus' },
  { value: 'CZ', description: 'Czechia' },
  { value: 'DK', description: 'Denmark' },
  { value: 'DJ', description: 'Djibouti' },
  { value: 'DM', description: 'Dominica' },
  { value: 'DO', description: 'Dominican Republic' },
  { value: 'EC', description: 'Ecuador' },
  { value: 'EG', description: 'Egypt' },
  { value: 'SV', description: 'El Salvador' },
  { value: 'GQ', description: 'Equatorial Guinea' },
  { value: 'ER', description: 'Eritrea' },
  { value: 'EE', description: 'Estonia' },
  { value: 'SZ', description: 'Eswatini' },
  { value: 'ET', description: 'Ethiopia' },
  { value: 'FK', description: 'Falkland Islands (Malvinas)' },
  { value: 'FO', description: 'Faroe Islands' },
  { value: 'FJ', description: 'Fiji' },
  { value: 'FI', description: 'Finland' },
  { value: 'FR', description: 'France' },
  { value: 'GF', description: 'French Guiana' },
  { value: 'PF', description: 'French Polynesia' },
  { value: 'TF', description: 'French Southern Territories' },
  { value: 'GA', description: 'Gabon' },
  { value: 'GM', description: 'Gambia' },
  { value: 'GE', description: 'Georgia' },
  { value: 'DE', description: 'Germany' },
  { value: 'GH', description: 'Ghana' },
  { value: 'GI', description: 'Gibraltar' },
  { value: 'GR', description: 'Greece' },
  { value: 'GL', description: 'Greenland' },
  { value: 'GD', description: 'Grenada' },
  { value: 'GP', description: 'Guadeloupe' },
  { value: 'GU', description: 'Guam' },
  { value: 'GT', description: 'Guatemala' },
  { value: 'GG', description: 'Guernsey' },
  { value: 'GN', description: 'Guinea' },
  { value: 'GW', description: 'Guinea-Bissau' },
  { value: 'GY', description: 'Guyana' },
  { value: 'HT', description: 'Haiti' },
  { value: 'HM', description: 'Heard Island and McDonald Islands' },
  { value: 'VA', description: 'Holy See' },
  { value: 'HN', description: 'Honduras' },
  { value: 'HK', description: 'Hong Kong' },
  { value: 'HU', description: 'Hungary' },
  { value: 'IS', description: 'Iceland' },
  { value: 'IN', description: 'India' },
  { value: 'ID', description: 'Indonesia' },
  { value: 'IR', description: 'Iran' },
  { value: 'IQ', description: 'Iraq' },
  { value: 'IE', description: 'Ireland' },
  { value: 'IM', description: 'Isle of Man' },
  { value: 'IL', description: 'Israel' },
  { value: 'IT', description: 'Italy' },
  { value: 'JM', description: 'Jamaica' },
  { value: 'JP', description: 'Japan' },
  { value: 'JE', description: 'Jersey' },
  { value: 'JO', description: 'Jordan' },
  { value: 'KZ', description: 'Kazakhstan' },
  { value: 'KE', description: 'Kenya' },
  { value: 'KI', description: 'Kiribati' },
  { value: 'KP', description: "Korea, Democratic People's Republic of" },
  { value: 'KR', description: 'Korea, Republic of' },
  { value: 'KW', description: 'Kuwait' },
  { value: 'KG', description: 'Kyrgyzstan' },
  { value: 'LA', description: "Lao People's Democratic Republic" },
  { value: 'LV', description: 'Latvia' },
  { value: 'LB', description: 'Lebanon' },
  { value: 'LS', description: 'Lesotho' },
  { value: 'LR', description: 'Liberia' },
  { value: 'LY', description: 'Libya' },
  { value: 'LI', description: 'Liechtenstein' },
  { value: 'LT', description: 'Lithuania' },
  { value: 'LU', description: 'Luxembourg' },
  { value: 'MO', description: 'Macao' },
  { value: 'MG', description: 'Madagascar' },
  { value: 'MW', description: 'Malawi' },
  { value: 'MY', description: 'Malaysia' },
  { value: 'MV', description: 'Maldives' },
  { value: 'ML', description: 'Mali' },
  { value: 'MT', description: 'Malta' },
  { value: 'MH', description: 'Marshall Islands' },
  { value: 'MQ', description: 'Martinique' },
  { value: 'MR', description: 'Mauritania' },
  { value: 'MU', description: 'Mauritius' },
  { value: 'YT', description: 'Mayotte' },
  { value: 'MX', description: 'Mexico' },
  { value: 'FM', description: 'Micronesia (Federated States of)' },
  { value: 'MD', description: 'Moldova, Republic of' },
  { value: 'MC', description: 'Monaco' },
  { value: 'MN', description: 'Mongolia' },
  { value: 'ME', description: 'Montenegro' },
  { value: 'MS', description: 'Montserrat' },
  { value: 'MA', description: 'Morocco' },
  { value: 'MZ', description: 'Mozambique' },
  { value: 'MM', description: 'Myanmar' },
  { value: 'NA', description: 'Namibia' },
  { value: 'NR', description: 'Nauru' },
  { value: 'NP', description: 'Nepal' },
  { value: 'NL', description: 'Netherlands' },
  { value: 'NC', description: 'New Caledonia' },
  { value: 'NZ', description: 'New Zealand' },
  { value: 'NI', description: 'Nicaragua' },
  { value: 'NE', description: 'Niger' },
  { value: 'NG', description: 'Nigeria' },
  { value: 'NU', description: 'Niue' },
  { value: 'NF', description: 'Norfolk Island' },
  { value: 'MK', description: 'North Macedonia' },
  { value: 'MP', description: 'Northern Mariana Islands' },
  { value: 'NO', description: 'Norway' },
  { value: 'OM', description: 'Oman' },
  { value: 'PK', description: 'Pakistan' },
  { value: 'PW', description: 'Palau' },
  { value: 'PS', description: 'Palestine, State of' },
  { value: 'PA', description: 'Panama' },
  { value: 'PG', description: 'Papua New Guinea' },
  { value: 'PY', description: 'Paraguay' },
  { value: 'PE', description: 'Peru' },
  { value: 'PH', description: 'Philippines' },
  { value: 'PN', description: 'Pitcairn' },
  { value: 'PL', description: 'Poland' },
  { value: 'PT', description: 'Portugal' },
  { value: 'PR', description: 'Puerto Rico' },
  { value: 'QA', description: 'Qatar' },
  { value: 'RE', description: 'Réunion' },
  { value: 'RO', description: 'Romania' },
  { value: 'RU', description: 'Russian Federation' },
  { value: 'RW', description: 'Rwanda' },
  { value: 'BL', description: 'Saint Barthélemy' },
  { value: 'SH', description: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', description: 'Saint Kitts and Nevis' },
  { value: 'LC', description: 'Saint Lucia' },
  { value: 'MF', description: 'Saint Martin (French part)' },
  { value: 'PM', description: 'Saint Pierre and Miquelon' },
  { value: 'VC', description: 'Saint Vincent and the Grenadines' },
  { value: 'WS', description: 'Samoa' },
  { value: 'SM', description: 'San Marino' },
  { value: 'ST', description: 'Sao Tome and Principe' },
  { value: 'SA', description: 'Saudi Arabia' },
  { value: 'SN', description: 'Senegal' },
  { value: 'RS', description: 'Serbia' },
  { value: 'SC', description: 'Seychelles' },
  { value: 'SL', description: 'Sierra Leone' },
  { value: 'SG', description: 'Singapore' },
  { value: 'SX', description: 'Sint Maarten (Dutch part)' },
  { value: 'SK', description: 'Slovakia' },
  { value: 'SI', description: 'Slovenia' },
  { value: 'SB', description: 'Solomon Islands' },
  { value: 'SO', description: 'Somalia' },
  { value: 'ZA', description: 'South Africa' },
  { value: 'GS', description: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', description: 'South Sudan' },
  { value: 'ES', description: 'Spain' },
  { value: 'LK', description: 'Sri Lanka' },
  { value: 'SD', description: 'Sudan' },
  { value: 'SR', description: 'Suriname' },
  { value: 'SJ', description: 'Svalbard and Jan Mayen' },
  { value: 'SE', description: 'Sweden' },
  { value: 'CH', description: 'Switzerland' },
  { value: 'SY', description: 'Syrian Arab Republic' },
  { value: 'TW', description: 'Taiwan' },
  { value: 'TJ', description: 'Tajikistan' },
  { value: 'TZ', description: 'Tanzania, United Republic of' },
  { value: 'TH', description: 'Thailand' },
  { value: 'TL', description: 'Timor-Leste' },
  { value: 'TG', description: 'Togo' },
  { value: 'TK', description: 'Tokelau' },
  { value: 'TO', description: 'Tonga' },
  { value: 'TT', description: 'Trinidad and Tobago' },
  { value: 'TN', description: 'Tunisia' },
  { value: 'TR', description: 'Turkey' },
  { value: 'TM', description: 'Turkmenistan' },
  { value: 'TC', description: 'Turks and Caicos Islands' },
  { value: 'TV', description: 'Tuvalu' },
  { value: 'UG', description: 'Uganda' },
  { value: 'UA', description: 'Ukraine' },
  { value: 'AE', description: 'United Arab Emirates' },
  { value: 'GB', description: 'United Kingdom' },
  { value: 'US', description: 'United States' },
  { value: 'UM', description: 'United States Minor Outlying Islands' },
  { value: 'UY', description: 'Uruguay' },
  { value: 'UZ', description: 'Uzbekistan' },
  { value: 'VU', description: 'Vanuatu' },
  { value: 'VE', description: 'Venezuela' },
  { value: 'VN', description: 'Viet Nam' },
  { value: 'VG', description: 'Virgin Islands (British)' },
  { value: 'VI', description: 'Virgin Islands (U.S.)' },
  { value: 'WF', description: 'Wallis and Futuna' },
  { value: 'EH', description: 'Western Sahara' },
  { value: 'YE', description: 'Yemen' },
  { value: 'ZM', description: 'Zambia' },
  { value: 'ZW', description: 'Zimbabwe' },
]

const feeExemptionCode = [
  { value: '1', description: 'Cotton (056) fee exempt for the cotton article' },
  { value: '2', description: 'Other agriculture fee exempt; Importer has obtained an organic product exemption certificate' },
]

const feeCode = [
  { value: '053', description: 'Beef Fee' },
  { value: '054', description: 'Pork Fee' },
  { value: '055', description: 'Honey Fee' },
  { value: '056', description: 'Cotton Fee' },
  { value: '057', description: 'Raspberry Fee' },
  { value: '079', description: 'Sugar Fee' },
  { value: '090', description: 'Potato Fee' },
  { value: '102', description: 'Lime Fee' },
  { value: '103', description: 'Mushroom Fee' },
  { value: '104', description: 'Watermelon Fee' },
  { value: '105', description: 'Softwood Lumber Fee' },
  { value: '106', description: 'Blueberry Fee' },
  { value: '107', description: 'Avocado Fee' },
  { value: '108', description: 'Mango Fee' },
  { value: '109', description: 'Sorghum Fee' },
  { value: '110', description: 'Dairy Product Fee' },
  { value: '124', description: 'Pecan Fee' },
  { value: '125', description: 'Christmas Tree Fee' },
  { value: '499', description: 'MPF' },
  { value: '501', description: 'HMF' }
]

const feeFormulaType = [
  { value: 'HEADER', description: 'Header' },
  { value: 'LINE_ITEM', description: 'Line Item' },
]

const feeFormulaCode = [
  { value: '053', description: 'Beef Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '054', description: 'Pork Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '055', description: 'Honey Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '056', description: 'Cotton Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '057', description: 'Raspberry Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '079', description: 'Sugar Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '090', description: 'Potato Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '102', description: 'Lime Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '103', description: 'Mushroom Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '104', description: 'Watermelon Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '105', description: 'Softwood Lumber Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '106', description: 'Blueberry Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '107', description: 'Avocado Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '108', description: 'Mango Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '109', description: 'Sorghum Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '110', description: 'Dairy Product Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '124', description: 'Pecan Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '125', description: 'Christmas Tree Fee', parent: 'type', code: 'LINE_ITEM' },
  { value: '499', description: 'MPF', parent: 'type', code: 'LINE_ITEM' },
  { value: '501', description: 'HMF', parent: 'type', code: 'LINE_ITEM' },
  { value: '311', description: 'Informal Fee', parent: 'type', code: 'HEADER' },
  { value: '496', description: 'Dutiable Mail Fee', parent: 'type', code: 'HEADER' },
  { value: '500', description: 'Manual Surcharge', parent: 'type', code: 'HEADER' },
]

const partyType = [
  { value: 'MF', description: 'Manufacturer' },
  { value: 'SE', description: 'Selling Party' },
  { value: 'BY', description: 'Buying Party' },
  { value: 'ST', description: 'Shipping to Party' },
  { value: 'LG', description: 'Stuffing Location' },
  { value: 'CS', description: 'Consolidator' },
  { value: 'CN', description: 'Consignee' },
  { value: 'IM', description: 'Importer' },
  { value: 'DN', description: 'Designated Notify Party' },
  { value: 'FF', description: 'Freight Forwarder' },
  { value: 'DEQ', description: 'Shipper' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)' },
  { value: 'DP', description: 'Delivered-To Party' },
  { value: 'PK', description: 'Point of Contact (Filer/Broker)' },
  { value: 'GD', description: 'Producer (Producer of the API)' },
  { value: 'FSV', description: 'Foreign Supplier Verification Program Importer' },
  { value: 'FDC', description: 'Consolidator' },
  { value: 'DFI', description: 'Grower' },
  { value: 'PNS', description: 'PN Submitter' },
  { value: 'PNT', description: 'PN Transmitter' },
  { value: 'UC', description: 'Ultimate Consignee' },
  { value: 'DFP', description: 'Owner' },
  { value: 'DII', description: 'Device Initial Importer' },
  { value: 'ITL', description: 'Independent Third Party Laboratory' },
  { value: 'LAB', description: 'Laboratory or Clinical Site' },
  { value: 'RD', description: 'Retailer/Distributor' },
  { value: 'TB', description: 'Submitter' }
]

const secSpecialProgram = [
  { value: 'C', description: 'Filer has or reasonably expects to have a Craft Beverage Modernization Act (CBMA) tax benefit assignment from the foreign producer and expects to file a refund claim with the Alcohol and Tobacco Tax and Trade Bureau (TTB) based on the assigned lower Internal Revenue Tax (IRT) rate or credit' },
  { value: 'F', description: 'A ‘folklore product’' },
  { value: 'G', description: 'A ‘made to measure’ suit of Hong Kong origin. The Category Codes associated with suits are 443, 444, 643, 644, 843 and 844' },
  { value: 'H', description: 'Certain garments in chapter 61 or 62' },
  { value: 'M', description: 'A textile fashion sample' }
]

const specialProgram = [
  { value: 'A', description: 'Generalized System of Preferences (GSP).' },
  { value: 'AU', description: 'Australia Free Trade Agreement.' },
  { value: 'B', description: 'Automotive Product Trade Act.' },
  { value: 'B#', description: 'Automotive Product Trade Act + FTA MPF Exemption.' },
  { value: 'BH', description: 'Bahrain Free Trade Agreement.' },
  { value: 'C', description: 'Agreement on Trade in Civil Aircraft.' },
  { value: 'C#', description: 'Agreement on Trade in Civil Aircraft + FTA MPF Exemption.' },
  { value: 'CA', description: 'North American Free Trade Agreement (NAFTA) – Canada. (Scheduled last day in effect: June 30, 2020)' },
  { value: 'CL', description: 'Chile Free Trade Act.' },
  { value: 'CO', description: 'Columbia Trade Promotion Agreement.' },
  { value: 'D', description: 'African Growth and Opportunity Act (AGOA).' },
  { value: 'E', description: 'Caribbean Basin Economic Recovery Act (CBERA); also known as the Caribbean Basin Initiative (CBI).' },
  { value: 'IL', description: 'U.S. – Israel Free Trade Area Agreement.' },
  { value: 'J', description: 'Andean Trade Preference Act (ATPA).' },
  { value: 'J+', description: 'Andean Trade Promotion and Drug Eradication Act (ATPDEA).' },
  { value: 'JO', description: 'Jordan Free Trade Agreement.' },
  { value: 'JP', description: 'U.S. – Japan Trade Agreement.' },
  { value: 'K', description: 'Agreement on Trade in Pharmaceutical Products.' },
  { value: 'K#', description: 'Agreement on Trade in Pharmaceutical Products + FTA MPF Exemption.' },
  { value: 'KR', description: 'U.S. – Korea Free Trade Agreement.' },
  { value: 'L', description: 'Uruguay Round Concessions on Intermediate Chemicals for Dyes.' },
  { value: 'L#', description: 'Uruguay Round concessions on Intermediate Chemicals for Dyes + FTA MPF Exemption.' },
  { value: 'MA', description: 'Morocco Free Trade Agreement.' },
  { value: 'MX', description: 'North American Free Trade Agreement (NAFTA) – Mexico. (Scheduled last day in effect: June 30, 2020)' },
  { value: 'N', description: 'A product of the West Bank, Gaza Strip (GZ), a qualifying industrial zone (Jordan), or Israel under the U.S. – Israel Free Trade Area Agreement.' },
  { value: 'NP', description: 'Nepal Preference Program.' },
  { value: 'OM', description: 'Oman Free Trade Agreement.' },
  { value: 'P', description: 'Originating Central American Free Trade Agreement (CAFTA).' },
  { value: 'PA', description: 'Panama Trade Promotion Agreement.' },
  { value: 'PE', description: 'Peru Trade Promotion Agreement.' },
  { value: 'P+', description: 'Qualifying Central American Free Trade Agreement (CAFTA).' },
  { value: 'R', description: 'Caribbean Basin Trade Partnership Act (CBTPA).' },
  { value: 'S', description: 'U.S.-Mexico-Canada Agreement (USMCA). (Entry into Force Date: July 1, 2020)' },
  { value: 'S+', description: 'Qualifying U.S.-Mexico-Canada Agreement (USMCA) commodities. (Entry into Force Date: July 1, 2020)' },
  { value: 'SG', description: 'Singapore Free Trade Act.' },
  { value: 'W', description: 'Products of Puerto Rico advanced in value or improved in condition in a CBERA country.' },
  { value: 'Y', description: 'U.S. Insular Possession.' },
  { value: 'Z', description: 'Freely Associated States.' }
]

const lcpoType = [
  { value: '01', description: 'Steel Import License' },
  { value: '02', description: 'Singapore TPL Certificate' },
  { value: '03', description: 'Canadian NAFTA TPL Certificate' },
  { value: '04', description: 'Mexican NAFTA TPL Certificate' },
  { value: '05', description: 'Beef Export Certificate' },
  { value: '06', description: 'Diamond Certificate' },
  { value: '07', description: 'Andean Drug Partnership Drug Eradication Act (ATPDEA) Certificate (HTS 98211119)' },
  { value: '08', description: 'Australia Free Trade Export Certificate' },
  { value: '09', description: 'Mexican Cement Import License' },
  { value: '10', description: 'CAFTA TPL Certificate' },
  { value: '11', description: 'Atlantic Lumber Board (ALB) Certificate' },
  { value: '12', description: 'Cotton Shirting Fabric License' },
  { value: '13', description: 'Haiti Earned Import Allowance' },
  { value: '14', description: 'Agricultural License' },
  { value: '16', description: 'Canadian Export Sugar Certificate' },
  { value: '17', description: 'Wool License' },
  { value: '18', description: 'Caribbean Basin Trade Partnership Act (CBTPA) Certification' },
  { value: '19', description: 'African Growth and Opportunity Act (AGOA) Textile Provision Number' },
  { value: '21', description: 'USDA Sugar Certificate' },
  { value: '22', description: 'Organic Product Exemption Certificate' },
  { value: '23', description: 'AMS Certificate of Exemption' },
  { value: '25', description: 'Dominican Republic Earned Allowance Program Certificate' },
  { value: '26', description: 'Mexican Sugar Export License' },
  { value: '27', description: 'General Note 15 (c) Waiver Certificate' },
  { value: '28', description: 'Aluminum Import License' },
  { value: '29', description: 'Canadian USMCA TPL Certificate' },
  { value: '30', description: 'Mexican USMCA TPL Certificate' },
  { value: '31', description: 'Argentine White Grape Juice Concentrate Export License' }
]

const irClassCode = [
  { value: '016', description: 'Distilled Spirits' },
  { value: '017', description: 'Wines' },
  { value: '018', description: 'Tobacco Products' },
  { value: '022', description: 'Other (not included above)' }
]

const otherIrClassCode = [
  { value: '672', description: 'Coffee Imports to Puerto Rico – Duty Assessment' }
]

const stsCert301 = [
  { value: '301STS CERT', description: 'Applicable' }
]

const bifacCert201 = [
  { value: '201BIFAC CERT', description: 'Applicable' }
]

const adcvdCert = [
  { value: 'ADCVD CERT', description: 'AD CVD document submitted via DIS' }
]

const primaryCountrySmeltApplicability = [
  { value: 'N', description: 'Not applicable' },
  { value: 'Y', description: 'Applicable' }
]

const secCountrySmeltApplicability = [
  { value: 'N', description: 'Not applicable' },
  { value: 'Y', description: 'Applicable' }
]

const programCode = [
  { value: 'TS1', description: 'Toxic Substance Control Act (TSCA)' },
  { value: 'ODS', description: 'Ozone Depleting Substances' }
]

const declaration = [
  { value: 'EP4', description: 'Positive Certification, I certify that all chemical substances in this shipment comply with all applicable rules or orders under TSCA and that I am not offering a chemical substance for entry in violation of TSCA or any applicable rule or order under TSCA.' },
  { value: 'EP5', description: 'Negative Certification, I certify that all chemicals in this shipment are not subject to TSCA.' }
]

const entityRoleCode = [
  { value: 'IM', description: 'Importer of Record' },
  { value: 'CB', description: 'Customs Broker' }
]

const laceyActDeclarationOption = [
  { value: 'Y', description: 'The entity has read the statement and certifies the data correct and signature is on file' }
]

const yesNoOption = [
  { value: 'Y', description: 'Yes' },
  { value: 'N', description: 'No' }
]

const programCodeOption = [
  { value: 'BIO', description: 'Biologic' },
  { value: 'COS', description: 'Cosmetic' },
  { value: 'DRU', description: 'Drug' },
  { value: 'VME', description: 'Animal Drug or Device' },
  { value: 'FOO', description: 'Food' },
  { value: 'DEV', description: 'Medical Device' },
  { value: 'RAD', description: 'Radiation-Emitting Products' },
  { value: 'TOB', description: 'Tobacco' }
]

const processingCodeOption = [
  { value: 'ALG', description: 'Allergenics', parent: 'programCode', code: 'BIO' },
  { value: 'BLO', description: 'Blood & Blood Products', parent: 'programCode', code: 'BIO' },
  { value: 'CGT', description: 'Cell and Gene Therapy', parent: 'programCode', code: 'BIO' },
  { value: 'HCT', description: 'Human Cells & Tissue', parent: 'programCode', code: 'BIO' },
  { value: 'VAC', description: 'Vaccines', parent: 'programCode', code: 'BIO' },
  { value: 'XEN', description: 'Xenotransplants', parent: 'programCode', code: 'BIO' },
  { value: 'BDP', description: 'Blood Derivatives', parent: 'programCode', code: 'BIO' },
  { value: 'BBA', description: 'Blood Bag with anti-coagulant', parent: 'programCode', code: 'BIO' },
  { value: 'BLD', description: 'Licensed Devices', parent: 'programCode', code: 'BIO' },
  { value: 'PVE', description: 'Plasma Volume Expanders', parent: 'programCode', code: 'BIO' },
  { value: 'PRE', description: 'Prescription', parent: 'programCode', code: 'DRU' },
  { value: 'OTC', description: 'Over the Counter', parent: 'programCode', code: 'DRU' },
  { value: 'RND', description: 'Research & Development', parent: 'programCode', code: 'DRU' },
  { value: 'INV', description: 'Investigational', parent: 'programCode', code: 'DRU' },
  { value: 'PHN', description: 'Pharmaceutical Necessities', parent: 'programCode', code: 'DRU' },
  { value: '804', description: 'Section 804 Importation Program***', parent: 'programCode', code: 'DRU' },
  { value: 'ADR', description: 'Animal Drug', parent: 'programCode', code: 'VME' },
  { value: 'ADE', description: 'Animal Device', parent: 'programCode', code: 'VME' },
  { value: 'NSF', description: 'Natural State Food', parent: 'programCode', code: 'FOO' },
  { value: 'PRO', description: 'Processed Food', parent: 'programCode', code: 'FOO' },
  { value: 'FEE', description: 'Animal Feed', parent: 'programCode', code: 'FOO' },
  { value: 'DSU', description: 'Dietary Supplement', parent: 'programCode', code: 'FOO' },
  { value: 'ADD', description: 'Additives and Colors', parent: 'programCode', code: 'FOO' },
  { value: 'CCW', description: 'Ceramicware or Food Contact Substance', parent: 'programCode', code: 'FOO' },
  { value: 'NED', description: 'Non-Radiation Emitting Device', parent: 'programCode', code: 'DEV' },
  { value: 'RED', description: 'Radiation-Emitting Device', parent: 'programCode', code: 'DEV' },
  { value: 'REP', description: 'Non-Medical Radiation-Emitting Product', parent: 'programCode', code: 'RAD' },
  { value: 'CSU', description: 'Consumer Use', parent: 'programCode', code: 'TOB' },
  { value: 'FFM', description: 'For further manufacturing', parent: 'programCode', code: 'TOB' },
  { value: 'INV', description: 'Investigational', parent: 'programCode', code: 'TOB' }
]

const sourceTypeOption = [
  { value: '39', description: 'Country of Production', parent: 'programCode', code: 'BIO' },
  { value: '30', description: 'Country of Source', parent: 'programCode', code: 'BIO' },
  { value: '294', description: 'Country of Refusal', parent: 'programCode', code: 'BIO' },
  { value: '39', description: 'Country of Production', parent: 'programCode', code: 'COS' },
  { value: '294', description: 'Country of Refusal', parent: 'programCode', code: 'COS' },
  { value: '39', description: 'Country of Production', parent: 'programCode', code: 'DRU' },
  { value: '30', description: 'Country of Source', parent: 'programCode', code: 'DRU' },
  { value: '294', description: 'Country of Refusal', parent: 'programCode', code: 'DRU' },
  { value: '39', description: 'Country of Production', parent: 'programCode', code: 'VME' },
  { value: '30', description: 'Country of Source', parent: 'programCode', code: 'VME' },
  { value: '294', description: 'Country of Refusal', parent: 'programCode', code: 'VME' },
  { value: '39', description: 'Country of Production', parent: 'programCode', code: 'FOO' },
  { value: '262', description: 'Place of Growth', parent: 'programCode', code: 'FOO' },
  { value: 'CSH', description: 'Country of Shipment', parent: 'programCode', code: 'FOO' },
  { value: '294', description: 'Country of Refusal', parent: 'programCode', code: 'FOO' },
  { value: '39', description: 'Country of Production', parent: 'programCode', code: 'DEV' },
  { value: '30', description: 'Country of Source', parent: 'programCode', code: 'DEV' },
  { value: '294', description: 'Country of Refusal', parent: 'programCode', code: 'DEV' },
  { value: '39', description: 'Country of Production', parent: 'programCode', code: 'RAD' },
  { value: '30', description: 'Country of Source', parent: 'programCode', code: 'RAD' },
  { value: '294', description: 'Country of Refusal', parent: 'programCode', code: 'RAD' },
  { value: '39', description: 'Country of Production', parent: 'programCode', code: 'TOB' },
  { value: '30', description: 'Country of Source', parent: 'programCode', code: 'TOB' },
  { value: '262', description: 'Place of Growth', parent: 'programCode', code: 'TOB' },
  { value: '294', description: 'Country of Refusal', parent: 'programCode', code: 'TOB' }
]

const lotNumberQualifierOption = [
  { value: '1', description: 'Manufacturer', parent: 'programCode', code: 'BIO' },
  { value: '1', description: 'Manufacturer', parent: 'programCode', code: 'COS' },
  { value: '1', description: 'Manufacturer', parent: 'programCode', code: 'DRU' },
  { value: '1', description: 'Manufacturer', parent: 'programCode', code: 'VME' },
  { value: '1', description: 'Manufacturer', parent: 'programCode', code: 'FOO' },
  { value: '3', description: 'Grower', parent: 'programCode', code: 'FOO' },
  { value: '1', description: 'Manufacturer', parent: 'programCode', code: 'DEV' },
  { value: '1', description: 'Manufacturer', parent: 'programCode', code: 'RAD' },
  { value: '3', description: 'Grower', parent: 'programCode', code: 'TOB' }
]

const temperatureQualifierOption = [
  { value: 'A', description: 'Ambient' },
  { value: 'F', description: 'Frozen' },
  { value: 'R', description: 'Refrigerated/Chilled' },
  { value: 'D', description: 'Dry Ice' },
  { value: 'H', description: 'Fresh' },
  { value: 'U', description: 'Uncontrolled' },
  { value: 'P', description: 'Flashpoint' }
]

const degreeTypeOption = [
  { value: 'F', description: 'Fahrenheit' },
  { value: 'C', description: 'Celsius' },
  { value: 'K', description: 'Kelvin' }
]

const entityRoleOption = [
  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'BIO' },
  { value: 'DEQ', description: 'Shipper', parent: 'programCode', code: 'BIO' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)', parent: 'programCode', code: 'BIO' },
  { value: 'DP', description: 'Delivered-To Party', parent: 'programCode', code: 'BIO' },
  { value: 'PK', description: 'Point of Contact(Filer/Broker)', parent: 'programCode', code: 'BIO' },

  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'COS' },
  { value: 'DEQ', description: 'Shipper', parent: 'programCode', code: 'COS' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)', parent: 'programCode', code: 'COS' },
  { value: 'DP', description: 'Delivered-To Party', parent: 'programCode', code: 'COS' },
  { value: 'PK', description: 'Point of Contact(Filer/Broker)', parent: 'programCode', code: 'COS' },

  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'DRU' },
  { value: 'DEQ', description: 'Shipper', parent: 'programCode', code: 'DRU' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)', parent: 'programCode', code: 'DRU' },
  { value: 'DP', description: 'Delivered-To Party', parent: 'programCode', code: 'DRU' },
  { value: 'PK', description: 'Point of Contact(Filer/Broker)', parent: 'programCode', code: 'DRU' },
  { value: 'SPO', description: 'Sponsor – if different than MF or FD1', parent: 'programCode', code: 'DRU' },
  { value: 'GD', description: 'Producer (Producer of the API*)', parent: 'programCode', code: 'DRU' },

  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'VME' },
  { value: 'DEQ', description: 'Shipper', parent: 'programCode', code: 'VME' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)', parent: 'programCode', code: 'VME' },
  { value: 'DP', description: 'Delivered-To Party', parent: 'programCode', code: 'VME' },
  { value: 'PK', description: 'Point of Contact(Filer/Broker)', parent: 'programCode', code: 'VME' },
  { value: 'GD', description: 'Producer (Producer of the API*)', parent: 'programCode', code: 'VME' },

  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'FOO' },
  { value: 'DEQ', description: 'Shipper', parent: 'programCode', code: 'FOO' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)', parent: 'programCode', code: 'FOO' },
  { value: 'DP', description: 'Delivered-To Party', parent: 'programCode', code: 'FOO' },
  { value: 'FSV', description: 'Foreign Supplier Verification Program Importer', parent: 'programCode', code: 'FOO' },
  { value: 'FDC', description: 'Consolidator', parent: 'programCode', code: 'FOO' },
  { value: 'DFI', description: 'Grower', parent: 'programCode', code: 'FOO' },
  { value: 'PNS', description: 'PN Submitter', parent: 'programCode', code: 'FOO' },
  { value: 'PNT', description: 'PN Transmitter', parent: 'programCode', code: 'FOO' },
  { value: 'LG', description: 'Location of Goods', parent: 'programCode', code: 'FOO' },
  { value: 'UC', description: 'Ultimate Consignee', parent: 'programCode', code: 'FOO' },
  { value: 'DFP', description: 'Owner', parent: 'programCode', code: 'FOO' },
  { value: 'PK', description: 'Point of Contact(Filer/Broker)', parent: 'programCode', code: 'FOO' },

  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'DEV' },
  { value: 'DEQ', description: 'Shipper', parent: 'programCode', code: 'DEV' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)', parent: 'programCode', code: 'DEV' },
  { value: 'DP', description: 'Delivered-To Party', parent: 'programCode', code: 'DEV' },
  { value: 'DII', description: 'Device Initial Importer', parent: 'programCode', code: 'DEV' },
  { value: 'PK', description: 'Point of Contact(Filer/Broker)', parent: 'programCode', code: 'DEV' },

  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'RAD' },
  { value: 'DEQ', description: 'Shipper', parent: 'programCode', code: 'RAD' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)', parent: 'programCode', code: 'RAD' },
  { value: 'DP', description: 'Delivered-To Party', parent: 'programCode', code: 'RAD' },
  { value: 'PK', description: 'Point of Contact(Filer/Broker)', parent: 'programCode', code: 'RAD' },

  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'TOB' },
  { value: 'DEQ', description: 'Shipper', parent: 'programCode', code: 'TOB' },
  { value: 'FD1', description: 'FDA Importer (Importer of Record)', parent: 'programCode', code: 'TOB' },
  { value: 'DP', description: 'Delivered-To Party', parent: 'programCode', code: 'TOB' },
  { value: 'ITL', description: 'Independent Third Party Laboratory', parent: 'programCode', code: 'TOB' },
  { value: 'LAB', description: 'Laboratory or Clinical Site', parent: 'programCode', code: 'TOB' },
  { value: 'RD', description: 'Retailer/Distributor', parent: 'programCode', code: 'TOB' },
  { value: 'TB', description: 'Submitter', parent: 'programCode', code: 'TOB' },
  { value: 'PK', description: 'Point of Contact(Filer/Broker)', parent: 'programCode', code: 'TOB' },

  { value: 'IM', description: 'Importer', parent: 'programCode', code: 'VNE' },
  { value: 'DFP', description: 'Owner', parent: 'programCode', code: 'VNE' },
  { value: 'STL', description: 'Storage Location', parent: 'programCode', code: 'VNE' },
  { value: 'CI', description: 'Certifying Individual', parent: 'programCode', code: 'VNE' },
  { value: 'MF', description: 'Manufacturer', parent: 'programCode', code: 'VNE' },
  { value: 'NAI', description: 'NAIC Bond Issuer', parent: 'programCode', code: 'VNE' },
]

const entityNumberTypeOption = [
  { value: '16', description: 'DUNS number' },
  { value: '47', description: 'FDA-assigned (FEI number)' }
]

const contactTypeOption = [
  { value: 'FD1', description: 'FDA Importer (Importer of Record)' },
  { value: 'PK', description: 'Point of Contact (Filer/Broker)' },
  { value: 'FSV', description: 'Foreign Supplier Verification Program Importer', parent: 'programCode', code: 'FOO' },
  { value: 'PNS', description: 'PN Submitter', parent: 'programCode', code: 'FOO' },
  { value: 'PNT', description: 'PN Transmitter', parent: 'programCode', code: 'FOO' }
]

const disAgency = [
  { value: 'CBP', description: 'Customs and Border Protection' },
  { value: 'FDA', description: 'Food and Drug Administration' },
  { value: 'USDA', description: 'USDA/APHIS' },
  { value: 'FSIS', description: 'USDA/FSIS' },
  { value: 'EPA', description: 'Environmental Protection Agency' },
  { value: 'CPSC', description: 'Consumer Product Safety Commission' },
  { value: 'FWS', description: 'Fish and Wildlife Service' },
  { value: 'TTB', description: 'Alcohol and Tobacco Tax and Trade Bureau' },
  { value: 'NHTSA', description: 'National Highway Traffic Safety Administration' },
  { value: 'FCC', description: 'Federal Communications Commission' },
  { value: 'DEA', description: 'Drug Enforcement Administration' },
  { value: 'ATF', description: 'Bureau of Alcohol, Tobacco, Firearms and Explosives' },
  { value: 'AMS', description: 'Agricultural Marketing Service' },
  { value: 'DOE', description: 'Department of Energy' },
  { value: 'BIS', description: 'Bureau of Industry and Security' },
  { value: 'DDTC', description: 'Directorate of Defense Trade Controls' },
  { value: 'NRC', description: 'Nuclear Regulatory Commission' },
]

const disDocumentType = [
  // CBP
  { value: 'INV', description: 'Commercial Invoice', parent: 'agency', code: 'CBP' },
  { value: 'PKL', description: 'Packing List', parent: 'agency', code: 'CBP' },
  { value: 'BOL', description: 'Bill of Lading', parent: 'agency', code: 'CBP' },
  { value: 'COO', description: 'Certificate of Origin', parent: 'agency', code: 'CBP' },
  { value: 'POA', description: 'Power of Attorney', parent: 'agency', code: 'CBP' },
  { value: 'FTA', description: 'Free Trade Agreement Certificate', parent: 'agency', code: 'CBP' },
  { value: 'CBP7501', description: 'Entry Summary (CF 7501)', parent: 'agency', code: 'CBP' },
  { value: 'CBP3461', description: 'Entry/Immediate Delivery (CF 3461)', parent: 'agency', code: 'CBP' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'CBP' },
  // FDA
  { value: 'PN', description: 'Prior Notice', parent: 'agency', code: 'FDA' },
  { value: 'IL', description: 'Import License', parent: 'agency', code: 'FDA' },
  { value: 'RC', description: 'Registration Certificate', parent: 'agency', code: 'FDA' },
  { value: 'FDAFORM', description: 'FDA Form', parent: 'agency', code: 'FDA' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'FDA' },
  // USDA/APHIS
  { value: 'PP', description: 'Phytosanitary Certificate', parent: 'agency', code: 'USDA' },
  { value: 'VS', description: 'Veterinary Health Certificate', parent: 'agency', code: 'USDA' },
  { value: 'IP', description: 'Import Permit', parent: 'agency', code: 'USDA' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'USDA' },
  // USDA/FSIS
  { value: 'FSIS', description: 'FSIS Import Inspection', parent: 'agency', code: 'FSIS' },
  { value: 'HC', description: 'Health Certificate', parent: 'agency', code: 'FSIS' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'FSIS' },
  // EPA
  { value: 'TSCA', description: 'TSCA Certification', parent: 'agency', code: 'EPA' },
  { value: 'NOA', description: 'Pesticide Notice of Arrival', parent: 'agency', code: 'EPA' },
  { value: 'VEH', description: 'Vehicle/Engine EPA Certificate', parent: 'agency', code: 'EPA' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'EPA' },
  // CPSC
  { value: 'COC', description: 'Certificate of Conformity', parent: 'agency', code: 'CPSC' },
  { value: 'TR', description: 'Test Report', parent: 'agency', code: 'CPSC' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'CPSC' },
  // FWS
  { value: 'DEC3177', description: 'FWS Declaration (Form 3-177)', parent: 'agency', code: 'FWS' },
  { value: 'CITES', description: 'CITES Permit', parent: 'agency', code: 'FWS' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'FWS' },
  // TTB
  { value: 'COA', description: 'Certificate of Age', parent: 'agency', code: 'TTB' },
  { value: 'COL', description: 'Certificate of Label Approval', parent: 'agency', code: 'TTB' },
  { value: 'IP', description: 'Import Permit', parent: 'agency', code: 'TTB' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'TTB' },
  // NHTSA
  { value: 'HS7', description: 'HS-7 Declaration', parent: 'agency', code: 'NHTSA' },
  { value: 'COMP', description: 'Compliance Letter', parent: 'agency', code: 'NHTSA' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'NHTSA' },
  // FCC
  { value: 'FCC740', description: 'FCC Form 740', parent: 'agency', code: 'FCC' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'FCC' },
  // DEA
  { value: 'DEA236', description: 'DEA Import Permit (Form 236)', parent: 'agency', code: 'DEA' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'DEA' },
  // ATF
  { value: 'ATF6', description: 'ATF Import Permit (Form 6)', parent: 'agency', code: 'ATF' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'ATF' },
  // AMS
  { value: 'GRD', description: 'Grade Certificate', parent: 'agency', code: 'AMS' },
  { value: 'OGC', description: 'Organic Certificate', parent: 'agency', code: 'AMS' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'AMS' },
  // DOE
  { value: 'EELC', description: 'Energy Efficiency Label Certificate', parent: 'agency', code: 'DOE' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'DOE' },
  // BIS
  { value: 'EXL', description: 'Export License', parent: 'agency', code: 'BIS' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'BIS' },
  // DDTC
  { value: 'DSP', description: 'DSP Import Authorization', parent: 'agency', code: 'DDTC' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'DDTC' },
  // NRC
  { value: 'NRL', description: 'NRC Import License', parent: 'agency', code: 'NRC' },
  { value: 'OTH', description: 'Other', parent: 'agency', code: 'NRC' },
]

const issuerLocationTypeOption = [
  { value: 'PR', description: 'Canadian Province' },
  { value: 'ISO', description: 'Country Code' },
  { value: 'MS', description: 'Mexican State' },
  { value: 'US', description: 'US State' }
]

const vneDeclarationOption = [
  { value: 'Y', description: 'Designates that the information provided is correct and all required information has been provided' },
]

const vneBondExemptionOption = [
  { value: 'E1Y', description: 'The engine is exempt from Bond' },
  { value: 'E1N', description: 'The engine is not exempt from Bond' },
]

const vneVinSerialNumberTypeOption = [
  { value: 'ENN', description: 'Engine Serial Number' },
  { value: 'SE', description: 'Serial Number ' },
  { value: 'AKG', description: 'Vehicle Identification Number (VIN) ' },
]

const vneTypeOption = [
  { value: '3520-1', description: 'EPA Form 3520-1' },
  { value: '3520-21', description: 'EPA Form 3520-21' },
]

const vneImportCodeOption = [
  { value: '1', description: 'U.S.-certified engine or engine installed in a certified vehicle' },
  { value: '2', description: 'National Security' },
  { value: '3', description: 'Manufacturer-owned engine' },
  { value: '4', description: 'Replacement engine' },
  { value: '5', description: 'Extraordinary circumstances/hardship' },
  { value: '6', description: 'Hardship for small volume manufacturers' },
  { value: '7', description: 'Equipment-manufacturer hardship' },
  { value: '8', description: 'Identical configuration' },
  { value: '10', description: 'Repairs or alterations' },
  { value: '11', description: 'Testing' },
  { value: '12', description: 'Display' },
  { value: '13', description: 'Export' },
  { value: '14', description: 'Diplomatic or military' },
  { value: '15', description: 'Delegated assembly' },
  { value: '16', description: 'Partially complete engine' },
  { value: '17', description: 'Engine manufactured before emission standards started to apply' },
  { value: '18', description: 'Competition engine' },
  { value: '19', description: 'Stationary compression-ignition engine with displacement at or above 30 liters per cylinder or stationary spark-ignition engine above 19kW that is not designed to run on gasoline or, if rich-burn, on liquefied petroleum gas.' },
  { value: '20', description: 'Underground mining' },
  { value: '21', description: 'Hobby engine' },
  { value: '22', description: 'Transition program for equipment manufacturers' },
  { value: '23', description: 'Personal-use exemption for small spark-ignition engines' },
  { value: '24a', description: 'Engine imported by an independent commercial importer recognized by EPA' },
  { value: '24b', description: 'Engine imported by an independent commercial importer recognized by EPA' },
  { value: '24c', description: 'Engine imported by an independent commercial importer recognized by EPA' },
  { value: '25', description: 'Other exemption' },
]

const vneIndustryCodeOption = [
  { value: 'A', description: 'Heavy-duty highway engines (for use in motor vehicles with gross vehicle weight rating above 8500LBS' },
  { value: 'B', description: 'Locomotives or locomotive engines' },
  { value: 'C', description: 'Marine compression-ignition engines' },
  { value: 'D', description: 'Other non-road compression-ignition engines' },
  { value: 'E', description: 'Marine spark-ignition engines' },
  { value: 'F', description: 'Recreational engines and vehicles, including snowmobiles, off-highway motorcycles, all-terrain vehicles, and off-road utility vehicles' },
  { value: 'G', description: 'Other non-road spark-ignition engines at or below 19kW or below 30kW if total displacement is at or below 1000cc' },
  { value: 'H', description: 'Other non-road spark-ignition engines above 19kW' },
  { value: 'I', description: 'Stationary compression-ignition engines' },
  { value: 'J', description: 'Stationary Spark-ignition engines' },
]

export {
  actionCode,
  entryType,
  modeOfTransportation,
  cargoReleaseProcessing,
  consolidatedIndicator,
  shipmentUsage,
  liveEntry,
  deferredTax,
  ftaReconciliation,
  otherReconciliation,
  paymentType,
  bondType,
  bondDesignationType,
  continuousBondIndicator,
  missingDoc1,
  missingDoc2,
  pscHeaderReasonCode,
  usStates,
  entryNumberSet,
  month,
  partyLookup,
  countries,
  feeExemptionCode,
  feeCode,
  feeFormulaType,
  feeFormulaCode,
  partyType,
  secSpecialProgram,
  specialProgram,
  lcpoType,
  irClassCode,
  otherIrClassCode,
  stsCert301,
  bifacCert201,
  adcvdCert,
  primaryCountrySmeltApplicability,
  secCountrySmeltApplicability,
  programCode,
  declaration,
  entityRoleCode,
  laceyActDeclarationOption,
  yesNoOption,
  issuerLocationTypeOption,
  contactTypeOption,
  entityNumberTypeOption,
  entityRoleOption,
  degreeTypeOption,
  temperatureQualifierOption,
  lotNumberQualifierOption,
  sourceTypeOption,
  processingCodeOption,
  programCodeOption,
  disAgency,
  disDocumentType,
  vneDeclarationOption,
  vneBondExemptionOption,
  vneVinSerialNumberTypeOption,
  vneTypeOption,
  vneImportCodeOption,
  vneIndustryCodeOption
}
